import ImgixClient from '@imgix/js-core';

export const imgixClient = new ImgixClient({
  domain: 'unisend.imgix.net',
  secureURLToken: process.env.IMGIX_SECRET,
});
